/**
 * This is a private class used by Slider
 * It is used to create a custom Mover to:
 * 1. Calculate the new pixel position of the Thumb
 * 2. Emit mousedragging and mousedragreleased events
 */

define([
    "dojo/_base/declare",
    "dojo/dom-geometry",

    //Dojo dnd
    "dojo/dnd/Mover"
],
    function(declare, domGeometry, Mover ){
        return declare(Mover,{

            /**
             * Continually call the setPixelValue to change the Thumb's position
             * by passing it the current position of the SliderThumb
             * Emits mousedragging event
             * @param e
             */
            onMouseMove: function (e) {
                var widget = this.widget;

                //get the cached version of the sliderTrack' domGeometry position
                var sliderTrackDimensions = widget._sliderTrackDimensions;

                //if it has not been cached yet, then do it here. to avoid domGeometry calls on every mouse move
                if (!sliderTrackDimensions) {
                    sliderTrackDimensions = widget._sliderTrackDimensions = domGeometry.position(widget.sliderTrackNode, true);
                }
                var pixelValue = e[widget._mousePixelCoord] - sliderTrackDimensions[widget._startingPixelCoord];

                if(widget._isScaleDirectionReverse){// true for the vertical slider
                    pixelValue = sliderTrackDimensions[widget._pixelCount] - pixelValue;
                }
                widget._setPixelValue(pixelValue, sliderTrackDimensions[widget._pixelCount], false); //throttle change event from firing on every move

                this._wasDragged = true;

                widget.emit("mousedragging");
            },

            /**
             * Emits mousedragreleased event and let the super-class - Mover.onMouseUp take over
             */
            onMouseUp: function () {
                var widget = this.widget;
                if(this._wasDragged){
                    widget.emit("mousedragreleased");
                    this._wasDragged = false;
                } else {
                    widget.emit("mouseclicked");
                }

                this.inherited(arguments);
            },

            /**
             * Clean up cached slider-track dimensions and let let super-class take over.
             * Mover.onMouseUp calls destroy()
             */
            destroy: function () {
                var widget = this.widget;
                widget._sliderTrackDimensions = null;
                this.inherited(arguments);
            }

        });
    });